import styled from '@emotion/styled'

export const ErrorContainer = styled.div<{ linkColor?: string; hoverColor?: string }>`
  text-align: center;
  margin: 3rem auto;
  max-width: 500px;

  a {
    color: ${(props) => (props.linkColor ? props.linkColor : '#0076FF')};
    text-decoration: none;
    font-size: 0.9rem;
    cursor: pointer;

    &:hover {
      color: ${(props) => (props.hoverColor ? props.hoverColor : '#0076FF')};
    }
  }
`

export const Header = styled.h1`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
`
export const Description = styled.div`
  white-space: pre-wrap;
  margin-bottom: 1.5rem;
`
